export function getRegistrationRedirect(searchParams: URLSearchParams): string | null {
  const requestedRedirect = searchParams.get('redirect');
  if (!requestedRedirect?.startsWith('/') || /^[/\\]{2}/.test(requestedRedirect)) return null;

  try {
    const applicationOrigin = 'https://ergshoot.local';
    const resolved = new URL(requestedRedirect, applicationOrigin);
    return resolved.origin === applicationOrigin ? requestedRedirect : null;
  } catch {
    return null;
  }
}

export function getRoleSelectionRedirect(searchParams: URLSearchParams): string {
  const redirect = getRegistrationRedirect(searchParams);
  return redirect ? `/select-role?redirect=${encodeURIComponent(redirect)}` : '/select-role';
}
